// react
import { compose, createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// roots
import user from './user';

let buildStore=compose( applyMiddleware( thunk ) )( createStore );
const rootReducer=combineReducers( { user } );
const store=buildStore( rootReducer );

export default store;